import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VSelect,
  VTextField,
  transitions,
  VProgressLinear,
  VForm,
  VDivider,
  VCard,
  VRadioGroup
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VSelect,
    VTextField,
    VProgressLinear,
    VDivider,
    VForm,
    VCard,
    VRadioGroup
  },
  theme: {
    primary: '#00B9B4',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#9D2595',
    success: '#4CAF50',
    warning: '#FFC107',
    gray: '#eaeaea',
    darkgray: '#1d1e20',
    teal: '#66d2d2',
    mint: '#0bb9b5',
    azure: '#06aaa0',
    grape: '#932c8e',
    midnight: '#0067a1',
    babyblue: '#d6f2f2',
    flatblack: '#1d1e1f',
  },
})
